package com.neurobs.js

import org.scalajs.dom.raw.HTMLElement
import org.scalajs.dom.AudioContext

import scala.scalajs.js
import scala.scalajs.js.annotation.JSGlobal

@js.native
trait PluginClass extends js.Object {
}

@js.native
trait SpectrogramPlugin extends PluginClass {
}

@js.native
trait SpectogramPluginOptions extends js.Object {
}

object SpectogramPluginOptions {
	def apply(container: HTMLElement, colorMap: js.Any, labels: Boolean, fftSamples: Int, windowfunc: String, height: Int) : SpectogramPluginOptions = {
		js.Dynamic.literal(
			container = container,
			labels = labels,
			fftSamples = fftSamples,
			windowFunc = windowfunc,
			colorMap = colorMap,
			height = height
		).asInstanceOf[SpectogramPluginOptions]
	}
}

@js.native
trait WaveSurferOptions extends js.Object {
}

object WaveSurferOptions {
	def apply(audioContext: AudioContext, container: HTMLElement, cursorColor: String, hideScrollbar: Boolean, height: Int, waveColor: String, normalize: Boolean, plugins: Option[js.Array[PluginClass]]): WaveSurferOptions = {
		val data = js.Dynamic.literal(
			audioContext = audioContext,
			container = container,
			cursorColor = cursorColor,
			hideScrollbar = hideScrollbar,
			height = height,
			waveColor = waveColor,
			normalize = normalize
		)
		plugins.foreach(data.updateDynamic("plugins")(_))
		data.asInstanceOf[WaveSurferOptions]
	}
}

@js.native
trait WaveSurfer extends js.Object {
	def loadDecodedBuffer(buffer: js.Any): js.Any = js.native
	def playPause(): js.Any = js.native
	def pause(): Unit = js.native
	def isPlaying(): Boolean = js.native
	def on(event: js.Any, callback: js.Any): js.Any = js.native
	def play(startTime: js.Any, stopTime: js.Any): js.Any = js.native
	def getCurrentTime(): Double = js.native
	def seekTo(progress: Double): js.Any = js.native
	def setDisabledEventEmissions(events: Seq[String]): Unit = js.native
}

@js.native
@JSGlobal
object WaveSurfer extends js.Object {

	def create(options: WaveSurferOptions): WaveSurfer = js.native

	@js.native
	object spectrogram extends js.Object {
		def create(options: SpectogramPluginOptions): SpectrogramPlugin = js.native
	}
}

